export default {
  // header
  headerImg: 'http://mk.chinaman.cn/mybigdatas/ids/static/top-text.png',
  headerTitle: 'MAIQS 2026',
  headerTitle1: 'International Conference on Measurement, AI, Quality and Sustainability',
  navList: [{
    text: "Home",
    url: "/",
    show: false,
  },
  {
    text: "Call For Papers",
    url: "/callforPapers",
    show: false,

  },
  {
    text: "Committees",
    url: "/committee",
    show: false,
  },
  {
    text: "Authors",
    url: "",
    show: false,
    children: [{
      text: "Full Paper Submission Instructions",
      url: "/submissions",
    },
    {
      text: "Important Dates",
      url: "/importantDates",
    },
    ],
  },
  {
    text: "Program",
    url: "aa",
    show: false,
    children: [{
      text: " Keynote Speakers ",
      url: "/speakers",
    },
    {
      text: " Special Sessions and Organisers ",
      url: "/organizingCommittees",
    },
    ],
  },
  {
    text: "Registration",
    url: "/reg",
    show: false,
  },
  /*
  {
    text: "Program",
    url: "",
    show: false,
    children: [{
      text: "Presentation Guides",
      url: "/",
    },
    {
      text: "Conference Program",
      url: "/",
    },
    {
      text: "Special Sessions and organisers",
      url: "/",
    },
    {
      text: "Keynote Speakers",
      url: "/",
    },
    ],
  },

  {
    text: "Venue",
    url: "",
    show: false,
    children: [{
      text: "Accommodation",
      url: "/",
    },
    ],
  },
  {
    text: "Conference Supporters",
    // url: "",
    show: false,
    url: "sb",
    children: [{
      text: "Partners",
      url: "/",
    },
    {
      text: "Sponsors & Exhibitors",
      url: "/",
    },
    {
      text: "Join as Sponsors or Exhibitor",
      url: "/",
    },
    ],
  },
  */
  {
    text: "Contact",
    url: "/contact",
    show: false,
  },
  ],
  // header
  // index
  indexTitle1: 'CALL FOR PAPERS',
  indexText1: `
  <p>The International Conference on Measurement, AI, Quality and Sustainability (MAIQS) is a premier conference series dedicated to advancing science and technology in these interconnected fields, addressing important industrial and societal challenges of the 21st century. MAIQS 2026 conference will bring together leading scholars, researchers and industry experts from around the world to discuss and share their latest insights and innovations in the field of measurement, AI, quality and sustainability. Working together, we endeavour to drive smarter and more sustainable solutions for industries and societies worldwide, contributing to a better future for all. </p>
  `,
  indexText2Title: 'Publication Opportunities',
  indexText2Text: `
  <p>Prospective authors are invited to submit full papers (4–6 A4 pages) to the conference. Accepted and presented papers will be published in the IET Conference Proceedings and hosted in the IET Digital Library. Selected high-quality papers will be invited for extension and submission to relevant SCI/EI indexed journals.
  </p>
  `,

  indexTitle2: 'Important Dates',
  indexdateList: [{
    date: "30th Sep 2026",
    oldDate: "18th Aug",
    text: "Full Paper Submission Deadline",
  },
  {
    date: "8th Oct 2026",
    text: "Paper Acceptance Notification",
  },
  {
    date: "15th Oct 2026",
    text: "Final Paper Submission Deadline"
  },
  {
    date: "15th Nov 2026",
    text: "Early Bird Registration Deadline",
  },
  {
    date: "08th Dec 2026",
    text: "Final Registration Deadline",
  },
  {
    date: "14th-16th Dec 2026",
    text: "Conference Dates",
  },
  ],
  indexTitle3: 'Related News',
  indexText3: 'First Announcement and Call for Papers',
  indexText4: 'TOPICS FOR MAIQS 2026 INCLUDE',
  indexText5: [{
    title: "Measurement: ",
    text: ""
  },
  {
    title: "Digital Calibration, Dynamic Standards and Traceability",
    text: ""
  },
  {
    title: "Measurement Theory, Errors and Uncertainty ",
    text: ""
  },
  {
    title: "Intelligent Sensors and Quantum Imaging",
    text: ''
  },
  {
    title: "Signal Processing, Data Analytics and AI for Measurement",
    text: ''
  },
  {
    title: "Metrology for Industry 4.0, IoT and Digital Twins",
    text: ''
  },
  {
    title: "Digital Transformation of Measurement Systems",
    text: ''
  },
  {
    title: "Artificial Intelligence",
    text: ''
  },
    // {
    //   title: "Machine Learning and Deep Leaning",
    //   text: ''
    // },
    // {
    //   title: "Embodied AI, Robotics and Autonomous Systems, Collaborative Robots, Mobile Robots, Humanoid Robots ",
    //   text: ''
    // },
    // {
    //   title: "Natural Language Processing (NLP) and Large Language Models (LLMs) ",
    //   text: ''
    // },
    // {
    //   title: "Explainable and Ethical AI, and AI Standardisation",
    //   text: ''
    // },
    // {
    //   title: "AI for Smart, Quality and Sustainable Systems ",
    //   text: ''
    // },
    // {
    //   title: "Advanced Machine Intelligence (AMI), Artificial General Intelligence (AGI), and Future AI Directions",
    //   text: ''
    // },
    // {
    //   title: "Quality: ",
    //   text: ''
    // },
    // {
    //   title: "AI-driven QFD, Inclusive Design, and TRIZ for Innovation ",
    //   text: ''
    // },
    // {
    //   title: "Statistical Process Control, Six Sigma, and Lean 4.0",
    //   text: ''
    // },
    // {
    //   title: "Inspection, Testing, Product Verifications and Conformity ",
    //   text: ''
    // },
    // {
    //   title: "Smart NDT/NDE, Predictive Maintenance, and Digital Asset Management",
    //   text: ''
    // },
    // {
    //   title: "Quality 4.0, TQM, Operational Excellence, and Social Responsibility",
    //   text: ''
    // },
    // {
    //   title: "Sustainability: ",
    //   text: ''
    // },
    // {
    //   title: "Deep Decarbonization Technologies for Hard-to-Abate Sectors",
    //   text: ''
    // },
    // {
    //   title: "AI-enabled Energy Efficiency 4.0 and Sector Coupling",
    //   text: ''
    // },
    // {
    //   title: "Dynamic LCA, Digital Product Passports, and Scope 3 Emissions",
    //   text: ''
    // },
    // {
    //   title: "Regenerative Economy, Urban Mining, and Critical Raw Materials Recovery",
    //   text: ''
    // },
    // {
    //   title: "Net Zero Pathways and Environmental, Social and Governance (ESG) Implementations",
    //   text: ''
    // },
    // {
    //   title: "Tipping Points, Climate Change and Sustainability",
    //   text: ''
    // },

    // {
    //   title: 'Cross-disciplinary:',
    //   text: ''
    // },
    // {
    //   title: "Generative HCI, Human-AI Teaming, Spatial Computing, and Digital Humans",
    //   text: ''
    // },
    // {
    //   title: "Multimodal Foundation Models and Cross-modal AI Systems",
    //   text: ''
    // },
    // {
    //   title: "6G, Industrial Internet, and Time-Sensitive Network",
    //   text: ''
    // },
    // {
    //   title: "AI-driven Additive Manufacturing, Industrial Metaverse, and Smart Factories",
    //   text: ''
    // },
    // {
    //   title: "MAIQS for Sustainable Aviation, Space Systems, and Resilient Supply Chains",
    //   text: ''
    // },
    // {
    //   title: "MAIQS for Precision Health, Smart Agriculture, and Digital Government",
    //   text: ''
    // },
    // {
    //   title: 'MAIQS for Autonomous Transport, Intelligent Infrastructure, and Net-zero Cities',
    //   text: ''
    // }
  ],
  indexText6: "Log in to My Dashboard",
  indexText7: "Email",
  indexText8: "Password",
  indexText9: "Login",
  indexText10: "Create Account",
  indexText11: "Please Login first before",
  indexText12: "Abstract submission",
  indexText13: "Full paper submission",
  indexText14: "Online registraction",
  indexText15: "Conference Scope and Topics",
  indexText16: "http://mk.chinaman.cn/mybigdatas/ids/static/theme.png",
  indexText17: "Confirmed Keynote Speakers",
  indexText18: [
    [{
      num: "002",
      title: "Prof. Arun S. Mujumdar",
      text: "McGill University",
      tip: "Canada",
    },
    {
      num: "001",
      title: "Prof. Alex Martynenko",
      text: "Dalhousie University",
      tip: "Canada",
    },
    {
      num: "018",
      title: "Prof. Azharul Karim",
      text: "Queensland University of Technology",
      tip: "Australia",
    },
    {
      num: "007",
      title: "Prof. Benu Adhikari",
      text: "RMIT University",
      tip: "Australia",
    },
    {
      num: "003",
      title: "Prof. Bhesh Bhandari",
      text: "University of Queensland",
      tip: "Australia",
    },
    ],
    [{
      num: "006",
      title: "Prof. Chung Lim Law",
      text: "University of Nottingham Malaysia",
      tip: "Malaysia",
    },
    {
      num: "026",
      title: "Dongxing Yu, Senior Engineer/General Manager",
      text: "SOHAO FD-Tech Co., Ltd.",
      tip: "China",
    },
    {
      num: "012",
      title: "Prof. Duu-Jong Lee",
      text: "City University of Hong Kong",
      tip: "China",
    },
    {
      num: "009",
      title: "Prof. Evangelos Tsotsas",
      text: "Otto von Guericke University Magdeburg",
      tip: "Germany",
    },
    {
      num: "022",
      title: "Prof. Gennadiy Semenov",
      text: "Russian Biotechnological University",
      tip: "Russia",
    },
    ],
    [{
      num: "011",
      title: "Prof. Hongwei Xiao",
      text: "China Agricultural University",
      tip: "China",
    },
    {
      num: "013",
      title: "Prof. Ireneusz Zbiciński",
      text: "Lodz University of Technology",
      tip: "Poland",
    }, {
      num: "015",
      title: "Prof. Itaya Yoshinori",
      text: "Gifu University",
      tip: "Japan",
    }, {
      num: "021",
      title: "Prof. Jamal Yagoobi",
      text: "Worcester Polytechnic Institute",
      tip: "America",
    }, {
      num: "027",
      title: "Dr. Jing Wu, Senior Engineer/Board Chairwoman",
      text: "Shandong Tianli Energy Co., Ltd. ",
      tip: "China",
    },

    ],
    [{
      num: "014",
      title: "Prof. Patrick Perre",
      text: "CentraleSupélec, Université Paris-Saclay",
      tip: "France",
    },
    {
      num: "016",
      title: "Prof. Peng Xu",
      text: "China Jiliang University",
      tip: "China",
    },
    {
      num: "004",
      title: "Prof. Sakamon Devahastin",
      text: "King Mongkut's University of Technology Thonburi",
      tip: "Thailand",
    },
    {
      num: "023",
      title: "Prof. Shaojin Wang",
      text: "Northwest A&F University",
      tip: "China",
    },
    {
      num: "008",
      title: "Prof. Shusheng Pang",
      text: "University of Canterbury",
      tip: "New Zealand",
    },
    ],
    [{
      num: "010",
      title: "Prof. Song Miao",
      text: "Teagasc Food Research Centre",
      tip: "Ireland",
    }, {
      num: "019",
      title: "Prof. Vijaya Raghavan",
      text: "McGill University",
      tip: "Canada",
    },
    {
      num: "005",
      title: "Prof. Xiao Dong Chen",
      text: "Soochow University",
      tip: "China",
    },
    {
      num: "020",
      title: "Prof. Xu Duan",
      text: "Henan University of Science and Technology",
      tip: "China",
    }, {
      num: '025',
      title: "Prof. Zhongli Pan",
      text: "University of California, Davis",
      tip: "America"
    }
    ]
  ],
  indexText19: "Contact us",
  indexText20: "Address:",
  indexText21: "School of Food Science and Technology, Jiangnan University, Wuxi, China",
  indexText22: "E-mail:",
  indexText23: "contact@maiqs2026.org",
  indexText24: "Website:",
  indexText25: "https://maiqs2026.org",
  indexText26: "Login successful",
  indexText27: '<div class="em-web" style="display:flex"><p><b> E-mail:</b> contact@maiqs2026.org</p><p><b> Website:</b> https://maiqs2026.org</p></div>',
  indexText28: "en",
  indexText29: "",
  indexText30: "",

  indexmsgemail: "Please enter your email address",
  indexmsgpwd: "Please enter your Password",
  // index

  //footer
  footReserved: 'Copyright © MAIQS 2026. All Rights Reserved',
  footSymposium: 'MAIQS 2026 | 23rd International Drying Symposium',
  footText1: "Beijing ICPB 20012029-3",

  //organizing
  organizingTitle1: 'Organizer: ',
  organizingTitle: 'China Jiliang University',
  organizingsmalltitle: 'General information',
  organizingtext1: "China Jiliang University (CJLU) is a multidisciplinary university featuring distinct strengths in metrology, standards, quality, market regulation, and inspection and quarantine. The university traces its origins back to 1978, when it was established as Hangzhou Metrology School by the State Metrology Bureau. In 1985, it was upgraded to China Institute of Metrology with the approval of the Ministry of Education, and in 2016, it was renamed China Jiliang University. Since 2019, CJLU has been jointly supported by the People's Government of Zhejiang Province and the State Administration for Market Regulation, and has been recognized as a key university in Zhejiang Province. In 2021, CJLU was authorized to confer doctoral degrees by the Academic Degrees Committee of the State Council, and in 2023, it successfully established two postdoctoral research stations in Instrument Science and Technology and Optical Engineering.",
  organizingtext2: "CJLU offers 2 doctoral programs in first-level disciplines, 15 academic master's degree programs in first-level disciplines and 15 professional master’s degree programs. The university has 9 first-class disciplines in Zhejiang Province, with 6 disciplines ranked in the top 1% globally by ESI. CJLU boasts 18 national first-class undergraduate programs, 4 national characteristic programs, 1 national pilot program for comprehensive reform, 4 programs accredited under the Yangtze River Delta New Liberal Arts Initiative, and 9 programs accredited by the National Engineering Education Accreditation. Additionally, it has 24 provincial first-class undergraduate programs, 7 provincial superior programs, 12 provincial characteristic programs, and 5 programs under the Ministry of Education's 'Excellent Engineer Education and Training Program'. CJLU also offers 14 national first-class courses, along with 7 national-level excellent courses, resource-sharing courses, and bilingual teaching demonstration courses. The university has 151 provincial first-class courses and 22 provincial excellent courses. It is home to 1 national experimental teaching demonstration center, 1 national virtual simulation experimental teaching center, and 14 provincial experimental teaching demonstration centers. CJLU also hosts 1 national experimental zone for talent cultivation model innovation and 1 national joint training demonstration base for professional master's degree in engineering, along with 15 provincial-level joint training bases.",
  // organizingtext3: ' Known as “the pearl of China ’s higher education in light industry”,Jiangnan University has launched a new journey toward the strategic objective of “building itself into a research- driven university with distinctive characteristics”, abiding by the motto of “learning and practice to perfection”.',
  // organizingsmalltitle2: 'Rankings',
  // organizingtext5: 'In the fourth round of National Discipline Assessment by the Ministry of Education, our Food Science and Technology, Light Industry Technology and Engineering was assessed at an “A+” level, and Design at an “A -”level.According to ESI, Jiangnan University ranks No.57 in China and our 10 disciplines(agricultural science, engineering, chemistry, biology & biochemistry, materials science, clinical medicine, computer science, pharmacology and toxicology, environment and ecology, microbiology) fall within the top 1 % globally and agricultural science is in 0.12‰. Jiangnan University is placed 60 nationwide and is in the 598th position globally by the US News rankings.',
  // organizingaddresss: 'Address',
  // organizingaddressstext: '1800 Lihu Avenue. Wuxi. Jiangsu. 214122. China',
  organizingdetails: 'Please see the details:',
  organizingtext10: "Postal",
  organizingtext11: "214122",
  organizingtext12: "https://www.cjlu.edu.cn/index.htm",
  organizingtext4: '',

  //coOrganizersTitle
  coOrganizersBigTitle: 'Co-organizers:',
  coOrganizersAboutTitle: '(Under construction)',
  coOrganizersTitle: '1. Drying Equipment Branch of China General Machinery Industry Association',
  coOrganizersText1: 'Drying Equipment Branch of China General Machinery Industry Association is a branch affiliated to China General Machinery Industry Association, which is one of the twelve professional branches of China General Machinery Industry Association and was established in 1993.',
  coOrganizersText2: "Drying Equipment Branch of China General Machinery Industry Association is a non-profit, nationwide social organization established in accordance with the law, approved and registered by the Ministry of Civil Affairs of the People's Republic of China, and voluntarily formed by domestic and foreign drying equipment enterprises, scientific research institutes, institutions of higher learning and other units.",
  coOrganizersText3: "Drying Equipment Branch of China General Machinery Industry Association takes promoting the development of China's drying equipment enterprises as its tenet, enhances the quality of the industry as its own responsibility, provides various services related to the industry for the government, the industry and the society, devotes itself to the industrial structural adjustment and the innovation of the growth mode, and, on the basis of increasing the brand cultivation, fostering and improvement of the domestically produced drying equipment, focuses its efforts on the communication and coordination with upstream and downstream industries as well as the communication and coordination among the enterprises and the government, and accelerates the pace of international cooperation. And accelerate the pace of international cooperation, and strive to create a favorable atmosphere for the development of Chinese drying equipment enterprises.",
  coOrganizersText4: "5th Floor, Unit 2, Block B, Wudong Buildings, No.9 Chegongzhuang Street, Xicheng District, Beijing, China",
  coOrganizersText5: " https://dr.cgmia.org.cn/About/AboutOne/11",


  //coOrganizersTitle

  coOrganizersTitleA1: 'International Research Association for Drying Science & Technology (Macao) ',
  coOrganizersTextA1: 'The International Research Association for Drying Science & Technology (Macao) (IRADSTM) was successfully registered in Macao in June 2024, becoming the only formally registered international academic organization in the field of drying science and technology. IRADSTM is a professional, academic, and non-profit organization voluntarily formed by experts in drying and related disciplines in the world. Its mission is to promote efficient and energy-saving drying processes and green development, advance the dissemination and application of drying science and cutting-edge technologies, foster the development of professionals in drying science and technology, and support the healthy, stable, and sustainable development of the international drying science and technology.',


  coOrganizersTitleA2: 'Drying Equipment Branch of China General Machinery Industry Association ',
  coOrganizersTextA21: 'Drying Equipment Branch of China General Machinery Industry Association is a branch affiliated to China General Machinery Industry Association, which is one of the twelve professional branches of China General Machinery Industry Association and was established in 1993.',
  coOrganizersTextA22: 'Drying Equipment Branch of China General Machinery Industry Association is a non-profit, nationwide social organization established in accordance with the law, approved and registered by the Ministry of Civil Affairs of the Peoples Republic of China, and voluntarily formed by domestic and foreign drying equipment enterprises, scientific research institutes, institutions of higher learning and other units.',
  coOrganizersTextA23: "Drying Equipment Branch of China General Machinery Industry Association takes promoting the development of China's drying equipment enterprises as its tenet, enhances the quality of the industry as its own responsibility, provides various services related to the industry for the government, the industry and the society, devotes itself to the industrial structural adjustment and the innovation of the growth mode, and, on the basis of increasing the brand cultivation, fostering and improvement of the domestically produced drying equipment, focuses its efforts on the communication and coordination with upstream and downstream industries as well as the communication and coordination among the enterprises and the government, and accelerates the pace of international cooperation.And accelerate the pace of international cooperation, and strive to create a favorable atmosphere for the development of Chinese drying equipment enterprises.",
  coOrganizersTextAB21: "5th Floor, Unit 2, Block B, Wudong Buildings, No.9 Chegongzhuang Street, Xicheng District, Beijing, China",
  coOrganizersTextAB22: " https://dr.cgmia.org.cn/About/AboutOne/11",




  coOrganizersTitleA3: 'China Jiliang University',
  coOrganizersTextA31: "China Jiliang University (CJLU) is an institution of higher learning featuring metrology, standards, quality, market supervision and inspection and quarantine, and was founded in 1978 by the State General Administration of Weights and Measures as Hangzhou School of Weights and Measures. The university has 2 first-level disciplines authorized for doctoral degree, 15 first-level disciplines authorized for master's degree, and 11 authorized for master's professional degree. There are 9 first-class disciplines in Zhejiang Province, and 4 disciplines in the top 1% of ESI global ranking. There are 18 national first-class majors, 4 national characteristic majors, 1 national comprehensive reform pilot major, and 9 national engineering education certification majors. The university has 19 colleges (departments and centers), with more than 18,000 full-time undergraduates, nearly 5,000 graduate students and more than 400 international students. There are nearly 1,500 full-time teachers in the university, including more than 20 national leading talents and more than 80 provincial and ministerial talents.",
  coOrganizersTextA32: "The university has more than 40 scientific research platforms at provincial and ministerial levels and 35 high-level research institutes, and has won three second prizes of national science and technology and more than a hundred awards at provincial and ministerial levels.",
  coOrganizersTextAB31: "No. 258, Xueyuan Street, Qiantang District, Hangzhou, Zhejiang, China",
  coOrganizersTextAB32: " https://english.cjlu.edu.cn/",


  coOrganizersTitleA4: 'China Agricultural University',
  coOrganizersTextA41: "China Agricultural University, founded in 1905 as the Agricultural University of Beijing University Hall, is the origin of China's modern agricultural higher education, a double first- class university directly under the Ministry of Education, and a high - level research university focusing on the construction of the “985 Project” and the “211 Project”. The current party secretary is Zhong Denghua.The current party secretary is academician Zhong Denghua and the president is academician Sun Qixin.China Agricultural University(CAU) was born and prospered because of agriculture, and is superior to agriculture, but not confined to agriculture.After a hundred years of development, China Agricultural University has developed into a research university with specialties and advantages in agronomy, life sciences, agricultural engineering and food sciences.There are 4 academicians of the Chinese Academy of Sciences, 11 academicians of the Chinese Academy of Engineering, and nearly 300 national talents such as Changjiang Scholars Distinguished Professors, Distinguished Youth Fund recipients, and National Ten Thousand People Plan Leaders; in the fourth round of the Ministry of Education's assessment of first-level disciplines, 6 disciplines such as Agricultural Engineering, Food Science and Engineering, Crop Science, Animal Husbandry, Veterinary Medicine, and Herbology were rated as A+ disciplines, ranking 6th among the national universities in the number of A+ disciplines; the number of A+ disciplines ranks 6th among the national universities.",
  coOrganizersTextA42: 'The number of A+ disciplines ranks the 6th among universities in China. There are 17 national research platforms in the university, including 9 national key laboratories, 1 national engineering laboratory, 2 national engineering technology research centers, 1 national R&D center, 1 national international joint research center and 3 national field scientific observation research stations; 129 provincial and ministerial research platforms, and the number of national key laboratories ranks the 4th in the country in terms of high efficiency. China Agricultural University has strong strength in basic research, and has published 34 high-level research papers in international famous magazines SCIENCE, CELL, NATURE and NATURE GENETICS; 15 disciplines have entered into the top 1% of ESI globally, and three disciplines such as plant and animal sciences, environment, and ecology have entered into the top 1,000 globally, and agricultural sciences are steadily ranked in the Agricultural Science is in the top 10,000 of the world.',
  coOrganizersTextAB41: "No.17 Qinghua East Road, Haidian District, Beijing, China",
  coOrganizersTextAB42: "https://en.cau.edu.cn/",


  coOrganizersTitleA5: 'Beijing Jiaotong University',
  coOrganizersTextA51: "Beijing Jiaotong University (BJTU) is a national key university directly under the Ministry of Education, which is jointly built by the Ministry of Education, the Ministry of Transportation, the Beijing Municipal People's Government and China State Railway Group Corporation, and is one of the universities constructed under the national “211 Project”, “985 Project Advantageous Discipline Innovation Platform” and “Double First Class” programs. It is a national key university under the “211 Project”, “985 Project Superior Discipline Innovation Platform” and “Double First Class” construction. Beijing Jiaotong University, as one of the three sources of Jiaotong University, with its historical origin dating back to 1896, is the birthplace of modern railroad management and telecommunication education in China. After the development of Double A, the university has 20 colleges, 15 disciplines are ranked as world-class disciplines by Soft Sciences, and the discipline of transportation engineering has been ranked first in the world for five times; 15 disciplines are ranked as disciplines in U.S. News World University Rankings; 7 disciplines are ranked as top disciplines in the world by QS; 23 disciplines are ranked as the best disciplines in China by Soft Sciences, and the disciplines of transportation engineering and system science continue to be ranked the first in China; 8 disciplines are ranked in ESI; and 8 disciplines are ranked as top disciplines in China by ESSI. Eight disciplines have entered the top 1% of ESI, and engineering remains in the top 1‰ of ESI. There are 17 postdoctoral research stations and 1 workstation in the university, 21 doctoral programs and 32 master's programs in the first-level disciplines. There are 3 academicians of the Chinese Academy of Sciences, 8 academicians of the Chinese Academy of Engineering, 1 foreign academician of the Chinese Academy of Engineering, 5 national teaching masters, 6 members of the Academic Degrees Committee of the State Council Discipline Evaluation Group, 76 teachers selected for various national talent programs, and 2 “four batches of” talents of the Propaganda Department, with about 30,000 students, 75 scientific research platforms above the provincial and ministerial levels. The university has about 30,000 students and 75 scientific research platforms at provincial and ministerial levels. The university has actively responded to the national “One Belt, One Road” initiative, and has established cooperative relationships with 252 universities and institutions in 51 countries, including the United States, Britain, Germany, France, etc. The university has also established strategic cooperative relationships with nearly 400 enterprises in the transportation, information, and energy industries, as well as with scientific and technological innovative enterprises, with 88 director units; 61 alumni organizations at home and abroad; and the Education Foundation has become a 4.0% partner of the Ministry of Civil Affairs; and the Education Foundation has become a 4.4% partner of the Ministry of Civil Affairs of China. The Education Foundation has become a 4A grade charitable organization recognized by the Ministry of Civil Affairs.",
  coOrganizersTextA52: "",
  coOrganizersTextAB51: "Beijing Jiaotong University No.3 Shangyuancun，Haidian District Beijing，China",
  coOrganizersTextAB52: "https://en.bjtu.edu.cn/",


  coOrganizersTitleA6: 'Institute of Food Science and Technology CAAS',
  coOrganizersTextA61: "The Institute of food science and technology of the Chinese Academy of Agricultural Sciences is a national scientific research institution of agricultural products processing, formerly known as the Institute of Atomic Energy Utilization of the Chinese Academy of Agricultural Sciences, which was restructured into the Institute of Agricultural Products Processing in October 2002 and opened in December 2003 upon the approval of the Ministry of Agriculture, the Ministry of Science and Technology, and the Editorial Office of the Central Committee of the Chinese Academy of Agricultural Sciences.The Institute is committed to solving the basic, directional, global and key scientific and technological problems of agricultural products processing, focusing on promoting the reduction of losses and supply of bulk agricultural products, improving the quality and efficiency of specialty agricultural products, and the research on food safety and industrial development strategy under the “big food concept”, so as to ensure food security and the stable and safe supply of important agricultural products, and to support the implementation of rural revitalization, healthy China and the development of the countryside, as well as to promote the development of the agricultural industry. It will perform the duties of a national team in guaranteeing food security and the stable and safe supply of important agricultural products, and comprehensively supporting the implementation of the strategies of rural revitalization, a healthy China and a strong manufacturing country.",

  coOrganizersTextAB61: "NO.2 YUANMINGYUAN WEST RD, HAIDIAN DISTRICT, BEIJING, 100193, P.R.CHINA",
  coOrganizersTextAB62: "https://ifst.caas.cn/en/",


  coOrganizersTitleA7: 'Jiangsu Academy of Agricultural Sciences',
  coOrganizersTextA71: "Jiangsu Academy of Agricultural Sciences is a comprehensive public welfare class I agricultural research institution directly belonging to the People's Government of Jiangsu Province, formerly known as the Central Agricultural Experimentation Institute founded by the former National Government in 1931, and has gone through the historical periods of East China Agricultural Science Institute, Jiangsu Branch of Chinese Academy of Agricultural Sciences, Jiangsu Provincial Agricultural Science Institute, etc., and it is one of the pioneers and founders of the development of modern agricultural science and technology organization and establishment in China. The academy has 16 specialized institutes, 11 agricultural area institutes, 2 scientific experimental stations, 97 scientific and technological innovation platforms above the ministerial and provincial levels, 1,218 acres of plant science bases and 3,316 acres of animal science bases in Lishui and Liuhe of Nanjing, respectively, and 8,860 acres of coastal modern agricultural scientific and technological innovation and demonstration bases in Yancheng. Jiangsu Academy of Agricultural Sciences has a complete set of disciplines and distinctive features, with agricultural sciences, plant and animal sciences in the top 1% of ESI global rankings.",
  coOrganizersTextA72: "There is one academician, five experts of the national “One Million Talents Project”, four national key talents, 72 experts with outstanding contributions at the provincial level and above, and 56 people enjoying the State Council's special allowances, and 56 people selected for the National Modern Agricultural Industrial Technology System (NAITS). There are 56 people enjoying special allowances under the State Council and 56 people selected for the National Modern Agricultural Industrial Technology System; it has signed comprehensive strategic cooperation agreements with FAO and other international organizations, and has established cooperative relations with 120 overseas high-level universities, scientific research institutes and high-efficiency institutes in “Belt and Road” countries.",
  coOrganizersTextAB71: "No. 50 Zhongling Street, Nanjing, Jiangsu Province",
  coOrganizersTextAB72: "http://en.jaas.ac.cn/Portals/Home/Index",

  coOrganizersTitleA8: 'Shaanxi University of Science and Technology',
  coOrganizersTextA81: "Shaanxi University of Science and Technology is a university under the national “Basic Capacity Building Project for Colleges and Universities in Central and Western China” and the “14th Five-Year Plan for Promoting a Stronger Education”, and a national “double first-class” cultivating university and a high-level university in Shaanxi Province. It is also a national “double first-class” cultivating university in Shaanxi Province and a high-level university under key construction. As the earliest light industry higher education institution, it was founded in 1958, moved to Xianyang, Shaanxi Province in 1970, and moved to Xi'an, Shaanxi Province in 2006. As one of the “West Relocation Group”, the university has cultivated more than 180,000 outstanding talents after more than 60 years of development and the struggle of “three creations and two relocations”. The university is ranked 124th in China in the 2024 Softech China University Ranking. The university has 16 colleges, 5 disciplines ranked in the top 1% of ESI global ranking, 10 world-class disciplines in soft science, 21 national first-class undergraduate majors, 9 national featured majors, and 19 engineering education certification majors in China. There are 4 postdoctoral research stations, 11 doctoral degree programs and 11 doctoral degree programs, 22 master's degree programs and 16 master's degree programs, and 70 undergraduate programs. There are “Yangtze River Scholars”, “Jieqing”, “Youqing”, “National High-level Talents Special Support Program”, “Ten Million Talents Project”, “National High-level Talents Special Support Program”, “National High-level Talents Special Support Program”, “National High-level Talents Special Support Program”, “National High-level Talents Special Support Program”, “National High-level Talents Special Support Program”, and “Ten Million Talents Project”. There are more than 100 national and provincial talents, such as “Changjiang Scholars”, “Jieqing”, “Youqing”, “National High-level Talents Special Support Program”, “One Hundred Million Talents Project”, etc. There are 84 key laboratories, key research bases and engineering and technology research centers at national, provincial and ministerial levels, 6 provincial postgraduate joint cultivation demonstration workstations, and 9 academician innovation teams. “Since the 13th Five-Year Plan, it has undertaken 3,031 vertical research projects, won 164 scientific and technological awards at the provincial and ministerial levels, published 141 books and 3,065 SCI papers, and authorized 3,875 domestic invention patents and 103 foreign patents. Through “one institute, one policy”, it has established close cooperation with more than 50 universities and scientific research institutions in more than 20 countries and regions, such as the United States, Canada, Germany, the United Kingdom, Australia, New Zealand, Kazakhstan, Hong Kong, Taiwan and so on. ",
  coOrganizersTextA82: " ",
  coOrganizersTextAB81: "Weiyang University Park, Xi'an, Shaanxi Province",
  coOrganizersTextAB82: " https://www.sust.edu.cn/",


  coOrganizersTitleA9: 'Soochow University',
  coOrganizersTextA91: "Soochow University is one of the first universities listed in the “211 Project” and “2011 Program” of China, a “double first-class” university jointly built by the Ministry of Education and the People's Government of Jiangsu Province, a key comprehensive university in Jiangsu Province, and a key university of Jiangsu Province, jointly built by the Ministry of Education and the People's Government of Jiangsu Province. Soochow University is a key comprehensive university in Jiangsu Province. Soochow University has 37 colleges (departments), 132 undergraduate majors, 47 first-level master's degree programs, 35 professional master's degree programs, 31 first-level doctoral degree programs, 1 professional doctoral degree program, 30 postdoctoral stations, 1 national first-class disciplines, and 4 national key disciplines. At present, five disciplines, including chemistry, materials science and engineering, are in the top 1 per cent of the global basic science indicators (ESI). In accordance with the development idea of “driving the domestic first-class with the international famous”, the university has comprehensively pushed forward the process of internationalization of education, and has established inter-university exchanges with more than 200 colleges and universities and research institutes in more than 30 countries, and has more than 1,000 international students coming to China from all over the world. The Department of Materials, Chemistry and Chemical Engineering of Soochow University, formerly known as the Department of Chemistry of Soochow University, was founded in 1914, and in 1917, two graduate students were awarded Master's degrees in Chemistry, the first Master's degrees conferred by Soochow University and the first Master's degrees in Chemistry in China to date. 2024, the Department of Chemistry and Chemical Engineering of Soochow University is celebrating the 110th anniversary of its founding. The Department of Chemistry and Chemical Engineering covers three first-level disciplines: Chemistry, Materials Science and Engineering, and Chemical Engineering and Technology, and has the right to grant doctoral degrees in three first-level disciplines as well as post-doctoral mobile stations. Materials Science and Engineering is a “first-class discipline”, and Chemistry and Chemical Engineering and Technology are the advantageous disciplines construction projects of Jiangsu Universities. 2024 Soft Science China Best Disciplines Ranking, Chemistry ranked 19th, Materials Science and Engineering ranked 19th, Chemical Engineering and Technology ranked 14th, all of them are in the top 12% in China. Chemistry, polymer materials and engineering, chemical engineering and technology majors for the national first-class undergraduate major construction sites and brand majors in Jiangsu Province, chemical engineering and technology majors approved by the Jiangsu Province Excellence in Engineer Education Cultivation Program 2.0 professional construction sites. The department has excellent research conditions, with two national research platforms, including the State-Local Joint Engineering Laboratory of New Functional Polymer Materials and the State-Local Joint Engineering Laboratory of Environmentally Friendly Functional Adsorbent Material Preparation Technology, as well as more than 10 provincial laboratories and more than 20 key laboratories at the municipal and university levels. We have made a number of scientific and technological achievements of international advanced level, and have won two second prizes of National Technological Invention Award, one second prize of National Science and Technology Progress Award, more than 20 provincial and ministerial scientific and technological awards, such as He Liang He Li Foundation Science and Technology Innovation Award, National Innovation Award for Pioneers, China Patent Excellence Award, and other provincial and ministerial scientific and technological awards. He has published papers in Science, Nature, Nat. Chem., Nat. Mater., Nat. Energy, Nat. Electron., J. Am. Chem. Soc., Angew. Chem. Int. Ed., Adv. Mater., AIChE J. and other international high-level academic journals. More than 100 papers have been published in the last three years. The Department of Materials, Chemistry and Chemical Engineering of Soochow University is located in Dushu Lake Higher Education Zone of Suzhou Industrial Park, which is an ideal place for study and research. The faculty and students of the Department of Materials and Chemistry warmly welcome students who are interested in making a difference in the field of Chemistry, Chemical Engineering and Materials to enter the Department for further study, and are also eagerly looking forward to the joining of outstanding scholars in Chemistry, Chemical Engineering and Materials at home and abroad.",
  coOrganizersTextA92: "",
  coOrganizersTextAB91: "No.1 Shizi Street, Gusu District, Suzhou, Jiangsu Province, China",
  coOrganizersTextAB92: "https://eng.suda.edu.cn/",


  coOrganizersTitleA10: 'Hezhou University',
  coOrganizersTextA101: "The former School of Food and Bioengineering of Hezhou University was the Department of Chemistry Teaching in Bapu Teachers' School of Wuzhou Region, which started to enroll 3-year college in 1977 and undergraduates in 2006, and established the School of Chemical and Biological Engineering in 2012, the Institute of Food Science and Engineering Technology in 2015, and renamed in December 2016 after some majors of the former School of Chemical and Biological Engineering were precipitated as the School of Food and Bioengineering College and merged with the Institute of Food Science and Engineering Technology until now.The University now has four undergraduate majors in food science and engineering, food quality and safety, bioengineering, and tea science. Among them, food science and engineering was approved as the characteristic specialty of the autonomous region in 2012, was selected for the construction of first-class disciplines (cultivation) in Guangxi in 2018 and successfully passed the mid-term performance evaluation in 2019, was selected as a first-class professional construction point in Guangxi in 2019, was selected as a national first-class professional construction point of the Ministry of Education's “Double Ten Thousand Plan” in 2020 in 2021, and was selected as a first-class undergraduate professional construction point of a new round of first-class disciplines (category B) in Guangxi in 2022. In 2021, it will be selected as a first-class undergraduate major construction point of the Ministry of Education's “Double Wan Plan” in 2020, and in 2022, it will be selected as a first-class discipline in the new round of Guangxi (Class B). In 2022, the major of food quality and safety will be selected as a first-class undergraduate major construction point at the provincial level in 2021.Bioengineering major is the earliest major in the history of the college.Tea science major is opened relying on local characteristic resources, and it is the earliest undergraduate major in tea science recruited by Guangxi colleges and universities.Fruit and Vegetable Storage and Preservation and Food Additives are recognized as the first- class undergraduate courses of the autonomous region in 2020. Food Chemistry” is recognized as the model course for the regional - level course on ideology and politics in general undergraduate colleges and universities in 2023.The college has a faculty with strong scientific research ability, high teaching level, reasonable academic qualifications, titles and age structure.There are 82 full - time teachers, including 11 with senior titles, 27 with associate titles, 80 with master's degrees or above, and 20 with double degrees.There are 82 full-time teachers, including 11 with senior titles, 27 with deputy senior titles, 80 with master's degrees or above, 22 dual - teacher teachers, 14 teachers with more than one year's experience of studying abroad; 3 part-time doctoral supervisors and 11 master's supervisors from outside the university.There is one external academician of the Chinese Academy of Engineering, one person enjoying the special government subsidy of the State Council, one member of the Teaching Steering Committee for Food Science and Engineering in Higher Education of the Ministry of Education, and six members of the Teaching Steering Committee for Undergraduate Higher Education of Guangxi from 2019 to 2022(among them, there is one director of food science and engineering, one secretary general, and two members; one member of the Teaching Steering Committee for Biological Science and Bioengineering 1 member; 1 member of the Teaching Steering Committee of Agriculture and Forestry), 1 special expert of Guangxi, 1 second - class professor, 1 high - level talent of Guangxi at the D level, 1 excellent outstanding scholar of Guangxi, and 1 Hejiang scholar.In 2015, Guangxi Fruit and Vegetable Preservation and Deep Processing Research Talent Small Highland was approved as the sixth batch of talent small highland in the autonomous region, and was rated as excellent in the work assessment in 2019.In 2018, Vegetables for Hong Kong and Macao Quality and Safety Control Research Innovation Team was selected as a high - level innovation team in Guangxi.With the goal of cultivating high - quality applied talents and the standard of engineering education accreditation, the college continuously improves its teaching conditions and teaching management level.The college has 7080 square meters of teaching and research rooms, instruments and equipment worth more than 40 million yuan, with food processing, product flavor regulation, comprehensive utilization of agricultural by - products, fruits and vegetables, such as the development and use of active ingredients and other professional laboratories, but also the construction of a pilot base, pilot production line and a series of complete supporting the theory of the school, the practice of teaching venues and facilities and a number of off - campus practice of teaching bases.In addition, there are a series of on - campus theoretical and practical teaching sites and facilities, such as pilot plant and pilot production line, as well as a number of off - campus practical teaching bases, which can fully meet the teaching needs of various specialties.In the past five years, teachers of the college have undertaken more than 100 scientific research projects, including 16 national projects, 48 provincial research projects, 18 municipal research projects, with vertical scientific research funding of more than 20 million yuan; nearly 100 horizontal scientific research projects to serve the local community, with funding of nearly 7 million yuan.It has won 1 second prize of Guangxi Natural Science and 1 third prize of Guangxi Scientific and Technological Progress.The funding for discipline and platform construction is more than 55 million yuan.Published 317 papers, including 75 SCI papers and 120 core papers.It has applied for 151 patents and formulated 4 local standards of Guangxi, which have been released and implemented.The college actively serves the local industry, and establishes long - term cooperative relationship with many enterprises such as Zhengda Group(Guangxi), Guangxi Hezhou Nongbei Beibei Agricultural and Animal Husbandry Science and Technology Co.Ltd, state - owned Dagui Mountain Forestry Farm of Guangxi Zhuang Autonomous Region, and Guangxi Generalfeng Tea Group Co.Ltd.through technology transfer and establishment of scientific research practice bases, which provides enterprises with advanced processing theories and key technologies, and improves the economic benefits of the enterprises.In 2015, it began to jointly cultivate postgraduates with Dalian University of Technology, in 2019, it began to jointly cultivate postgraduates with Sumy National Agricultural University of Ukraine, and in 2020, it began to jointly cultivate postgraduates with Guangxi University of Science and Technology, with a cumulative total of 77 postgraduates being jointly cultivated.The University actively carries out foreign exchanges and cooperation, hosting the National Symposium on Deep Processing and Preservation Technology of Horseshoe in 2016, the First Conference on Industrial Development of Lotus Root and Aquatic Plants in 2017, the Sixth Conference on Development of China's Leisure Food Industry and the Second International Symposium on Nutrition and Health of Foods in 2018, and the Fifth International Symposium on Drying of Foodstuffs and the International Symposium on Non-thermal Processing of Foodstuffs in 2019. In 2020, we will co-sponsor the 4th International Symposium on Fresh Food Processing and Preservation, in 2021, we will co-sponsor the 3rd International Symposium on Food Science and Nutritional Health, and in 2023, we will co-sponsor the Guidelines for Teaching of Food Science and Engineering in Higher Education Institutions under the Ministry of Education. In 2023, it will co-sponsor the Steering Committee for Teaching of Food Science and Engineering Programs in Higher Educational Institutions of the Ministry of Education and the Sixth International Symposium on Fresh Food Processing and Preservation, and co-sponsor the Fourth International Symposium on Food Science and Nutritional Health.",

  coOrganizersTextAB101: "No.3261 Xiahe Avenue, Babu District, Hezhou City, Guangxi Province, China",
  coOrganizersTextAB102: "https://www.hzxy.edu.cn/",

  coOrganizersTitleA11: 'Zhejiang University of Science and Technology ',
  coOrganizersTextA111: "The university was founded by Zhejiang University and Hangzhou City in 1980, and became a project construction unit for granting doctoral degrees in Zhejiang Province in 2022, and was renamed Zhejiang University of Science and Technology (ZUST) in 2023. After more than 40 years of construction, the university has developed into a first-class applied undergraduate university with internationalized operation and distinctive regional characteristics. The university now has two campuses in Xiaohuoshan, Hangzhou and Anji, Huzhou, covering an area of more than 2,900 mu. There are 17 secondary colleges and one teaching department; 56 undergraduate majors, 6 academic master's degree authorized first-level disciplines, 8 master's degree authorized points; there are more than 19,000 full-time undergraduate and graduate students, and more than 1,400 international students coming to China. The university has a team of excellent talents with international vision, high academic level, high moral and ethical standards, and reasonable echelon structure. There are more than 1,700 teaching staff on staff, with more than 1,360 full-time teachers, including nearly 550 teachers with senior titles and 61% of them with doctoral degrees. ",
  coOrganizersTextA112: "There are nearly 30 top and national talents and nearly 120 provincial and ministerial talents such as Zhejiang Province special experts, National High-level Talents Special Support Program, “Yangtze River Scholars and Innovative Teams Development Program” innovative team leaders, National Project of One Hundred Million Talents, and Young and Middle-aged Experts with Outstanding Contributions of the State.",
  coOrganizersTextAB111: "No. 318 Liuhe Road, Hangzhou, Zhejiang, China",
  coOrganizersTextAB112: "https://en.zust.edu.cn/",


  coOrganizersTitleA12: 'Sericulture and Agri-Food Research Institute of Guangdong Academy of Agricultural Sciences',
  coOrganizersTextA121: "Sericulture and Agri-Food Research Institute of Guangdong Academy of Agricultural Sciences, founded in 1952, is a provincial scientific research institution of the second category of public welfare, mainly engaged in the scientific research and promotion of two major fields of agricultural products processing and sericulture science and technology, with research areas covering fruits and vegetables, grain and oil, livestock and poultry, aquatic products, preservation of freshness, functional foods and sericulture and other industries. The Institute has built a whole chain innovation platform system of upstream and downstream integration of “basic research - core technology - engineering and application” around the industrial chain, and has established the cultivation base of State Key Laboratory of Agricultural Product Processing, Functional Food Key Laboratory of the Ministry of Agriculture and Rural Development, Guangdong Key Laboratory of Agricultural Product Processing, and Guangdong Key Laboratory of Agricultural Product Processing. Key Laboratory of Guangdong Province, Key Laboratory of Agricultural Product Processing, National Local Joint Engineering Research Center of Tropical Subtropical Fruit and Vegetable Processing Technology, Guangdong Province Agricultural Product Processing Technology Pilot Public Service, Guangdong Province Joint Research Institute of Prepared Vegetable Industry, Guangdong Province Agricultural Product Processing Service Industrial Park and other national and provincial scientific research platforms 28, instruments and equipment worth more than 100 million yuan. The institute insists on party building and scientific research, and has cultivated 6 experts with special government subsidies under the State Council, 2 national advanced workers (model workers), 1 effective candidate for academician of the Chinese Academy of Engineering, 2 national ",
  coOrganizersTextA122: "Ten Thousand People Plan” scientific and technological innovation leaders, 2 Shennong leaders and 2 young talents, and a number of high-level talents. In recent years, it has won 3 second prizes for national scientific and technological progress and 15 first prizes for provincial and ministerial-level science and technology; it was awarded the Provincial Civilized Unit in 2005 and has been retained until now, and was awarded the May 1st Labor Certificate of Guangdong Province in 2024.",
  coOrganizersTextAB121: "No.133 Dongguanzhuang 1 Heng Road, Tianhe District, Guangzhou City, Guangdong Province, China",
  coOrganizersTextAB122: "http://www.gdaas.cn/srigaas/",

  //committee
  committeebigtitle: 'Committee',
  committeeOrganizing: 'Conference Board',
  committeeheaderImg: 'http://mk.chinaman.cn/mybigdatas/ids/static/commit.png',
  committeeScientific: 'Scientific Committee (MAIQS Advisory Panel)',
  committeepeopleList: [{
    name: "Zhang M.",
    text: "Jiangnan University, Wuxi, P.R. China (MAIQS 2026 Chairman)",
  },
  {
    name: "Bi J.F.",
    text: "Institute of Food Science and Technology, CAAS, Beijing, P.R. China",
  },
  {
    name: "Chen X.D.",
    text: "Soochow University, Suzhou, P.R. China",
  },
  {
    name: "Duan X.",
    text: "Henan University of Science and Technology, Luoyang, P.R. China",
  },
  {
    name: "Huang L.X.",
    text: "Institute of Chemical Industry of Forest Products, Nanjing, P.R. China",
  },
  {
    name: "Jin J.H.",
    text: "Nanjing Institute for Comprehensive Utilization of Wild Plants, China CO-OP，Nanjing，P.R.Chinas",
  },
  {
    name: "Li D.J.",
    text: "Institute of Agro-product Processing, JAAS, Nanjing, P.R. China",
  },
  {
    name: "Li S.B.",
    text: "Jiangsu BoLaiKe Refrigeration Science and Technology Development Co., Ltd., Changzhou, P.R. China",
  },
  {
    name: "Li Z.Y.",
    text: "Tianjin University of Science and Technology, Tianjin, P.R. China",
  },
  {
    name: "Wang S.J.",
    text: "Northwest A&F University, Yangling, P.R. China",
  },
  {
    name: "Wu Z.H.",
    text: "Tianjin University of Science & Technology, Tianjin, P.R. China",
  },
  {
    name: "Xiao H.W.",
    text: "China Agricultural University, Beijing, P.R. China",
  },
  {
    name: "Yu D.X.",
    text: "SOHAO FD-TECH CO., LTD., Qingdao, P.R. China",
  },
  {
    name: "Zha G.C.",
    text: "Changzhou Yibu Drying Equipment Co., Ltd., Changzhou, P.R. China",
  },
  {
    name: "Zhou C.S.",
    text: "Jiangsu University, Zhenjiang, P.R. China",
  },
  ],
  committeetableData: [{
    date: "1",
    name: "Mujumdar A.S. (Canada)",
    address: "Devahastin S. (Thailand)",
  },
  {
    date: "2",
    name: "Abdelghani, B. (Algeria)",
    address: "Abdenouri, N. (Morocco)",
  },
  {
    date: "3",
    name: "Akinola A. (Nigeria)",
    address: "Alves-Filho O. (Norway)",
  },
  {
    date: "4",
    name: "Andrieu J. (France)",
    address: "Barresi A. (Italy)",
  },

  {
    date: "5",
    name: "Bruttini R. (Italy)",
    address: "Bhandari B. (Australia)",
  },
  {
    date: "6",
    name: "Chen G. (Hong Kong, P.R. China)",
    address: "Chen X. D. (P.R. China)",
  },
  {
    date: "7",
    name: "Farkas I. (Hungary)",
    address: "Emam-Djomeh Z. (Iran)",
  },

  {
    date: "8",
    name: "Itaya Y. (Japan)",
    address: "Fortes M. (Brazil)",
  },
  {
    date: "9",
    name: "Kemp I. (UK)",
    address: "Kechaou N. (Tunisia)",
  },
  {
    date: "10",
    name: "Krokida M. (Greece)",
    address: "Kowalski S. (Poland)",
  },

  {
    date: "11",
    name: "Langrish T. (Australia)",
    address: "Kudra T. (Canada)",
  },
  {
    date: "12",
    name: "Leonard A. (Belgium)",
    address: "Law C.L. (Malaysia)",
  },
  {
    date: "13",
    name: "Miao S. (Ireland)",
    address: "Levy A. (Israel)",
  },

  {
    date: "14",
    name: "Opara L. (South Africa)",
    address: "Mulet A. (Spain)",
  },
  {
    date: "15",
    name: "Pang S. (New Zealand)",
    address: "Pakowski Z. (Poland)",
  },
  {
    date: "16",
    name: "Perré P. (France)",
    address: "Peczalski R. (France)",
  },
  {
    date: "17",
    name: "Rodriguez-Ramirez (Mexico)",
    address: "Raghavan V. (Canada)",
  },
  {
    date: "18",
    name: "Rosello C. (Spain)",
    address: "Renstrom R. (Sweden)",
  },

  {
    date: "19",
    name: "Prachayawarakorn S. (Thailand)",
    address: "Sarkar Md. S.H. (Bangladesh)",
  },
  {
    date: "20",
    name: "Sihem, B. (Tunisia)",
    address: "Schutyser M. (Netherlands)",
  },

  {
    date: "21",
    name: "Thorat B. (India)",
    address: "Taranto O. (Brazil)",
  }, {
    date: "22",
    name: "Tsotsas E. (Germany)",
    address: "Timofeev O. (Finland) ",
  }, {
    date: "23",
    name: "Zbicinski I. (Poland)",
    address: "Yagoobi J. (USA)",
  }, {
    date: "24",
    name: "Zhou W. (Singapore)",
    address: "Zhang, M. (P.R. China) ",
  },
  ],

  //session
  sessionbigtitle: 'Keynotes',
  sessiontitle: 'Confirmed Keynote Speakers',
  sessionText18: [{
    num: "002",
    title: "Prof. Arun S. Mujumdar",
    text: "McGill University",
    tip: "Canada",
  },
  {
    num: "001",
    title: "Prof. Alex Martynenko",
    text: "Dalhousie University",
    tip: "Canada",
  },
  {
    num: "018",
    title: "Prof. Azharul Karim",
    text: "Queensland University of Technology",
    tip: "Australia",
  },
  {
    num: "007",
    title: "Prof. Benu Adhikari",
    text: "RMIT University",
    tip: "Australia",
  },
  {
    num: "003",
    title: "Prof. Bhesh Bhandari",
    text: "University of Queensland",
    tip: "Australia",
  },
  {
    num: "006",
    title: "Prof. Chung Lim Law",
    text: "University of Nottingham Malaysia",
    tip: "Malaysia",
  },
  {
    num: "026",
    title: "Dongxing Yu, Senior Engineer/General Manager",
    text: "SOHAO FD-Tech Co., Ltd.",
    tip: "China",
  },
  {
    num: "012",
    title: "Prof. Duu-Jong Lee",
    text: "City University of Hong Kong",
    tip: "China",
  },
  {
    num: "009",
    title: "Prof. Evangelos Tsotsas",
    text: "Otto von Guericke University Magdeburg",
    tip: "Germany",
  },
  {
    num: "022",
    title: "Prof. Gennadiy Semenov",
    text: "Russian Biotechnological University",
    tip: "Russia",
  },
  {
    num: "011",
    title: "Prof. Hongwei Xiao",
    text: "China Agricultural University",
    tip: "China",
  },
  {
    num: "013",
    title: "Prof. Ireneusz Zbiciński",
    text: "Lodz University of Technology",
    tip: "Poland",
  },
  {
    num: "015",
    title: "Prof. Itaya Yoshinori",
    text: "Gifu University",
    tip: "Japan",
  },
  {
    num: "021",
    title: "Prof. Jamal Yagoobi",
    text: "Worcester Polytechnic Institute",
    tip: "America",
  }, {
    num: "027",
    title: "Dr. Jing Wu, Senior Engineer/Board Chairwoman",
    text: "Shandong Tianli Energy Co., Ltd. ",
    tip: "China",
  },
  {
    num: "014",
    title: "Prof. Patrick Perre",
    text: "CentraleSupélec, Université Paris-Saclay",
    tip: "France",
  },
  {
    num: "016",
    title: "Prof. Peng Xu",
    text: "China Jiliang University",
    tip: "China",
  },
  {
    num: "004",
    title: "Prof. Sakamon Devahastin",
    text: "King Mongkut's University of Technology Thonburi",
    tip: "Thailand",
  },
  {
    num: "023",
    title: "Prof. Shaojin Wang",
    text: "Northwest A&F University",
    tip: "China",
  },
  {
    num: "008",
    title: "Prof. Shusheng Pang",
    text: "University of Canterbury",
    tip: "New Zealand",
  },
  {
    num: "010",
    title: "Prof. Song Miao",
    text: "Teagasc Food Research Centre",
    tip: "Ireland",
  },
  {
    num: "019",
    title: "Prof. Vijaya Raghavan",
    text: "McGill University",
    tip: "Canada",
  },
  {
    num: "005",
    title: "Prof. Xiao Dong Chen",
    text: "Soochow University",
    tip: "China",
  },
  {
    num: "020",
    title: "Prof. Xu Duan",
    text: "Henan University of Science and Technology",
    tip: "China",
  },
  {
    num: '025',
    title: "Prof. Zhongli Pan",
    text: "University of California, Davis",
    tip: "America"
  }
  ],
  //program
  programbigtitle: 'Keynotes',
  programbigtext: 'This page is under construction.',

  //submissions
  submissionsbigtitle: 'Submissions',
  submissionstitle1: 'Topics of Interest',
  submissionstitle2: 'Full Paper Submission Instructions',
  submissionstitle3: 'Important Dates',
  submissionstitle4: 'Submission Method',
  submissionstext42: 'Full paper should be prepared according to the following template:',
  submissdataList: [
    'Measurement',
    'Artificial Intelligence',
    'Quality',
    'Sustainability',
    'Cross-disciplinary',
  ],
  submissionstext21: '1. Paper Length: Full papers should be 4-6 A4 pages, including references',
  submissionstext22: '2. Review Process: The work must be original and unpublished and not under review in any other conference or journal. All contributions will be peer-reviewed by the Scientific Committee based on their originality, significance, methodological soundness and clarity of exposition.',
  submissionstext23: '3. Publication: Accepted and presented papers will be published in the IET Conference Proceedings and hosted in the IET Digital Library. Each published paper will receive a DOI. Selected high-quality papers will be invited for extension and submission to relevant SCI/EI indexed journals.',

  submissionstext31a: '30th May 2026:',
  submissionstext32a: '8th June 2026:',
  submissionstext33a: '15th June 2026:',
  submissionstext34a: '15th July 2026:',
  submissionstext35a: '15th August 2025:',

  submissionstext31b: 'Paper Acceptance Notification ',
  submissionstext32b: 'Notification of abstract',
  submissionstext33b: 'Final Paper Submission',
  submissionstext34b: 'Early Bird Registration',
  submissionstext35b: 'Final Registration',

  submissionstext41: 'For those who want to do "Oral Presentation and Poster" or "Poster Only" , abstract should be prepared according to the following template: ',
  submissionstext43: 'Online Submission Link',
  submissionstext45: 'Online Submission Link',
  submissionstext46: 'Online Submission System',


  //reg
  regbigtitle: 'Registration',
  regtitle1: 'Registration & Payment',
  regtitle2: 'Refund Policy:',

  regtext11: '1. Please fill the information and complete the payment via',
  regtext11a: 'Online Registration & Payment Information.',
  regtext11b: 'Please Note: The uploaded "Payment Voucher Screenshot" will be verified by the secretary within ten days (Cross-border payments have a longer delay).',
  regtext12: '2. Please upload “Payment Voucher Screenshot (Payment Order ID)” OR email it to',
  regtext12a: 'and wait for the secretary’s confirmation.',

  regCategory: 'Category',
  regtableData: [{
    one: "Student Registration",
    two: "¥1,500",
    three: "€200",
    four: "US$220",
  },
  {
    one: "Faculty Registration",
    two: "¥2,000",
    three: "€260",
    four: "US$300",
  },
  ],
  regColCNY: 'CNY (RMB)',
  regColEUR: 'EUR',
  regColUSD: 'USD',
  regDomesticTitle: 'Domestic registration',
  regScanRegister: 'Please scan the code to register：',
  regScanPay: 'Please scan the code to pay：',
  regNoteName: 'Please note your name when making the payment.',
  regOverseasTitle: 'Overseas registration',
  regOverseasLink: 'Overseas registration link',
  regPaymentRemittance: 'payment and remittance：',
  regCompanyNameCn: '公司名称：艾笛特（杭州）网络科技有限公司',
  regCompanyNameEn: '英文名称：Editor（Hangzhou）Network Technology Co.，Ltd',
  regBankOpenBank: '公司开户银行：中信银行杭州玉泉支行',
  regBankAccountNo: '银行帐号：8110801013202190203',
  regBankSwift: 'SWIFT CODE: CIBKCNBJ310',
  regBankNameEn: '银行名称：China CITIC Bank Hangzhou Branch',
  regBankAddress: '银行地址：NO.9 EAST JIEFANG ROAD, HANGZHOU, ZHEJIANG PROVINCE, P.R.CHINA',
  regFeeScheduleTitle: 'MAIQS 2026 Registration Fee Schedule',
  regFeesTitle: 'Registration Fees',
  regConferenceWebsite: 'Conference website: https://www.maiqs2026.org/index/index.html#/',
  regNoEarlyBird: 'Registration fees: No early-bird pricing applies.',
  regNoteIncludes: '* Each student or faculty registration includes one paper.',
  regNoteOfficial: '* The amounts shown above are the official registration fees for MAIQS 2026.',
  regpayabout1: 'Registration Fee (CNY)',
  regpayabout2: 'Normal Full registration After July 01, 2024 aaa【excluding banquet&Cultural activity fee】',


  regtext21a: 'Jiangnan University Bank Account 1 (US Dollar Remittance):',
  regtext22a: 'Bank of China, Wuxi Branch',
  regtext23a: 'No.258 Zhongshan Road, Wuxi，214002，Jiangsu, P. R. China',
  regtext24a: 'BKCHCNBJ95C',
  regtext25a: '',
  regtext26a: '* Banquet & Cultural activity : 50 USD',

  regtextbb01: 'Beneficiary: ',
  regtextbb02: 'Jiangnan university',
  regtextbb03: 'No.1800 Lihu Road, Wuxi，214122,Jiangsu，P.R.China',
  regtextbb04: '474158228044',
  regtextbb05: '0510-85913145',

  regtext21b: 'Jiangnan University Bank Account 2 (RMB Remittance)',
  regtext22b: 'Account Name: Jiangnan University(江南大学)',
  regtext23b: 'Account Bank: Wuxi Jiangnan University Branch, Industrial and Commercial Bank of China(工商银行无锡江南大学支行)',
  regtext24b: 'Bank account number: 1103030709100000136',

  regtext31: 'Registrations that are cancelled before September 01, 2024 will be reimbursed at 80% of the fee. Cancellations made after September 01, 2024 will not be reimbursed.',
  regtext32: ' Cancellation and refund request must be made formally via email. No shows will not be refunded.The organizing committee is not responsible for problems beyond our control, such as weather conditions, campus conditions, travel difficulties, visa problems, etc.',
  regtext33: ' * The organizing committees reserves the right to change the dates and place of the conference due to force majeure.',
  regtext34: ' * Losses thus incurred from the force majeure events shall not be liabled and refunds policy shall not apply as well.',

  submissionstext44: 'Online Submission System',
  //awards

  awardstitle: 'MAIQS 2026 Awards',
  awardstitle1: '1. Arun S Mujumdar Medal',
  awardstitle2: "2. MAIQS 2026 Chairman's Award",
  awardstitle3: '3. Young Drying Scientist Award',
  awardstitle4: '4. Excellent Oral Presentation Award',
  awardstitle5: '5. Excellent Poster Presentation Award',
  awardstitle6: '6. Oral Presentation Award',
  awardstitle7: '7. Poster Presentation Award',






  //sponsors
  sponsorsbigtitle: 'Sponsors',
  sponsorstext: 'This page is under construction.',

  //visa
  visabigtitle: 'Visa',
  visabigtitle1: 'VISA information:',
  visatext1: ' VISA Invitation Letters may be provided upon request. In order for the request to be honored, you must be the author or co- author of an accepted abstract.Please download this',
  visatext2: 'Invitation Letter Template,',
  visatext3: 'Please fill in your information and send to the conference email: ',
  visatext4: 'contact@maiqs2026.org',
  visatext5: '',
  visatext6: 'After signed and stamped, it will be emailed to you. ',
  visatext7: '* Important information regarding invitation letters (please read):',
  visatext8: 'Please note MAIQS2026 Conference and the organizing committee of the conference are not authorized to assist with the VISA process beyond providing the Notification of Invitation Letter issued by MAIQS2026 Conference and conference Committee Board. Should your application be denied, MAIQS Conference and the organizing committee of the conference cannot change the decision of the Ministry of Foreign Affairs, nor will MAIQS Conference and the organizing committee of the conference engage in discussion or correspondence with the MOFA or the Embassy on behalf of the applicant. ',
  visatext9: 'It takes time for the Embassy to process the VISA application, please register as early as you can to make sure you have enough time.',


  //travel
  travelbigtitle: 'Venue',
  traveltext1: 'The MAIQS 2026 will be held in the Worldhotel Grand Juna Hotel Wuxi.',
  traveltext2: 'Worldhotel Grand Juna Wuxi',
  traveltext3: ' ：111 Hefeng Road, Binhu District,Wuxi, Jiangsu, P.R.China',
  traveltext4: 'Hotel Website:',
  traveltext5: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9686.475195985919!2d120.31601149071314!3d31.47841453112593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b385201cf2d979%3A0x7edb48baa0649d06!2z5Lit5Zu95rGf6IuP55yB5peg6ZSh5biC5ruo5rmW5Yy65rKz5Z-S5Y-j5peg6ZSh5ZCb5p2l5LiW5bCK6YWS5bqXIOmCruaUv-e8lueggTogMjE0MTMy!5e0!3m2!1szh-CN!2sus!4v1701435358974!5m2!1szh-CN!2sus',
  travelText6: "en",
  //traveltwo
  traveltwobigtitle: 'Travel',
  traveltwotext: 'This page is under construction.',

  //hotel
  hotelbigtitle: 'Hotel',
  hoteltext: 'This page is under construction.',


  //submissionUpload
  submissionUploadtitle: 'Conference info',
  submissionUploadtext1: '23rd International Drying Symposium (MAIQS 2026)',
  submissionUploadtext2: 'Conference Date:',
  submissionUploadtext3: 'November 22-25, 2024',
  submissionUploadtext4: 'Venue',
  submissionUploadtext5: 'Worldhotel Grand Juna Wuxi, Wuxi, China',
  // submissionUploadtext5: "Please enter a title",

  submissionUploadtitle: 'Paper info',

  submissionUploadtext21: 'Author Information',
  submissionUploadtext22: 'Email address will only be used for communication with the authors，corresponding author will receive email from the system about this submission, at least one corresponding author should be marked.',
  submissionUploadAuthor: 'Author',
  submissionUploadAuthortext: '(Please fill in at least one author information)',
  submissionUploadtext23: 'Click here to add more authors',
  submissionUploadtext24: 'delete',
  submissionUploadtext25: 'Submitted Successfully!',
  submissionUploadtext26: "The file size cannot exceed 200M",
  submissionUploadtext30: 'First Name:*',
  submissionUploadtext31: 'Middle Name:',
  submissionUploadtext32: 'Last Name:*',
  submissionUploadtext33: 'Position:',
  submissionUploadtext34: 'Affiliation:*',
  submissionUploadtext35: 'Email:*',
  submissionUploadtext36: 'Corresponding author:',
  submissionUploadtext37: 'Oral presentation author:',
  submissionUploadtext38: 'position',
  submissionUploadtext39: '',
  submissionUploadtext40: '',


  submissionUploadmoreauthors: 'Click here to add more authors',

  submissionUploadmessageTitle: "Please enter title",
  submissionUploadmessageAbstract: "Please enter Abstract",
  submissionUploadmessagekeyword: "Please enter keyword",
  submissionUploadmessagefile: "Please upload the file",
  submissionUploadmessageauthor: "Please enter author",

  submissionUploadmessageauthor1: "Please enter Author",
  submissionUploadmessageauthor1Firstname: "s Firstname",
  submissionUploadmessageauthor1Lastname: "s Lastname",
  submissionUploadmessageauthor1Position: "s Position",
  submissionUploadmessageauthor1Affiliation: "s Affiliation",
  submissionUploadmessageauthor1email: "s email",

  submissionUploadSubmissionType: 'Submission Type:*',
  submissionUploadAbstract: 'Abstract (Oral Presentation and Poster)',
  submissionUploadPosterOnly: 'Abstract (Poster  Only)',
  submissionUploadFullpaper: 'Full paper submission is not available now. When your Abstract is notified of acceptance on March 31, 2024, you may choose to begin the full paper submission.',
  submissionUploadtitleandAbstract: 'Title And Abstract',
  submissionUploadTitle: 'Title:',
  submissionUploadTitleAbstract: 'Abstract:',
  submissionUploadAbstractabout: 'The title and the abstract should be entered as plain text, they should not contain HTML elements.',
  submissionUploadKeywords: 'Keywords:',
  submissionUploadKeywordsabout: 'Specify at least three keywords, separated by comma.:',
  submissionUploadselect: 'select file:',
  submissionUploadabouts: 'If you have compeleted the form, Please press the "Submission" button below.Uploading may take a while, please do not click the button twice.',

  submissionUploadSubmission: 'Submission',
  submissionUploadPeopleList: [
    [{
      text: "First Name:*",
      value: "",
      radio: "a",
    },
    {
      text: "Middle Name:",
      value: "",
      radio: "a",
    },
    {
      text: "Last Name:*",
      value: "",
      radio: "a",
    },
    {
      text: "Position:",
      value: "",
      radio: "c",
      list: [{
        text: "Position",
      },
      {
        text: "Prof.",
      },
      {
        text: "Associate Prof.",
      },
      {
        text: "Assiatant Prof.",
      },
      {
        text: "Dr.",
      },
      {
        text: "Master",
      },
      {
        text: "Seniot Lecturer",
      },
      {
        text: "Lecturer",
      },
      {
        text: "Ph.D student",
      },
      {
        text: "Master student",
      },
      {
        text: "Undergraduate student",
      },
      {
        text: "Others",
      },
      ],
    },
    {
      text: "Affiliation:*",
      value: "",
      radio: "a",
    },
    {
      text: "Email:*",
      value: "",
      radio: "a",
    },
    {
      text: "Corresponding author:",
      value: "1",
      radio: "b",
    },
    {
      text: "Oral presentation author:",
      value: "1",
      radio: "d",
    },
    ],
  ],
  submissionUploadItem: [{
    text: "First Name:*",
    value: "",
    radio: "a",
  },
  {
    text: "Middle Name:",
    value: "",
    radio: "a",
  },
  {
    text: "Last Name:*",
    value: "",
    radio: "a",
  },
  {
    text: "Position:*",
    value: "",
    radio: "c",
    list: [{
      text: "Position",
    },
    {
      text: "Prof.",
    },
    {
      text: "Associate Prof.",
    },
    {
      text: "Assiatant Prof.",
    },
    {
      text: "Dr.",
    },
    {
      text: "Master",
    },
    {
      text: "Seniot Lecturer",
    },
    {
      text: "Lecturer",
    },
    {
      text: "Ph.D student",
    },
    {
      text: "Master student",
    },
    {
      text: "Undergraduate student",
    },
    {
      text: "Others",
    },
    ],
  },
  {
    text: "Affiliation:*",
    value: "",
    radio: "a",
  },
  {
    text: "Email:*",
    value: "",
    radio: "a",
  },
  {
    text: "Corresponding author:",
    value: "1",
    radio: "b",
  },
  {
    text: "Oral presentation author:",
    value: "1",
    radio: "d",
  },
  ],
  //loginThen
  loginThenbigtitle: 'My Conference Dashboard',
  loginThentitle1: 'Online Submission System',
  loginThentiftle12: '(Abstract/Full paper)',
  loginThentitle2: 'Registration',
  loginThentitle3: 'Registration & Payment',
  loginThentitle4: 'Invitation Letter',
  loginThentextabout: 'For speakers, you need to upload an "Abstract/Full paper"',
  loginThenUpload: 'Upload',
  loginThenbigtitle23: 'Proceedings of MAIQS 2026',
  loginThenbigtitle231: '(Exclusive to Registered Attendees)',
  loginThenbigtitle24: '1、Abstracts, MAIQS 2026 Proceedings:',
  loginThenbigtitle25: "2、Full Paper, MAIQS 2026 Proceedings",

  loginThenPaperID: 'Paper ID',
  loginThentitle: 'title',
  loginThensubmissionType: 'submissionType',
  loginThenkeywords: 'keywords',
  loginThensuEdit: 'Edit',
  loginThenDelete: 'Delete',

  //simpleReg
  simpleRegTitle: 'title',
  simpleRegFirstname: 'Firstname',
  simpleRegLastname: 'Lastname',
  simplePassword: 'Password',
  simplePasswordpic: 'The password length needs to be 6-15',
  simpleRetypePassword: 'Retype Password',
  simpleCode: 'Verification Code* (Case sensitive)',
  simpleSignin: 'Sign in',
  simpleSignintip1: 'Already have an account?',
  simpleSignintip2: 'Please login',

  simpleSignmsgemail: 'Please enter your email address',
  simpleSignmsgFirstname: 'Please enter your Firstname',
  simpleSignmsgLastname: 'Please enter your Lastname',
  simpleSignmsgPassword: 'Please enter your Password',

  simpleSignmsgRetypePassword: 'Please enter your Retype Password',
  simpleSignmsgPasswordinconsistency: 'Password inconsistency',

  simpleSignmsgpasswordpic: 'The password length needs to be 6-15',
  simpleSignmsgCode: 'Please enter Verfication Code',
  simpleSignmsgCodeinconsistency: 'Verfication Code inconsistency',
  simpleSignmsgRegistrationsuccessful: 'Registration successful',

  newsDetailText1: 'Extension abstract submission deadline is March 15',
  newsDetailText2: '[Notification] The deadline for abstract submission is extended until March 15.',
  newsDetailText3: 'We hope to make the symposium more informative and interesting by giving more people the opportunity to actively participate in the symposium and share their latest research results.',
  newsDetailText4: 'Looking forward for your abstract, we look forward to your participation in MAIQS!',
  newsDetailText5: '1 Week Left to Deadline for Abstract Submission',
  newsDetailText6: '-- Updated on March 8, 2024',
  newsDetailText7: 'en',
  newsDetailText8: '1 Week Left to Deadline for Full Paper Submission',
  newsDetailText9: "-- Updated on April 23, 2024",
  newsDetailText10: "Registration & Payment, Hotel Reservation, VISA Invitation Letters, are in full swing!",

  newsDetailText10up: "-- Updated on July 9, 2024",
  newsDetailimgurl: "news.pic2.png",

  newsDetailTexttitle11: "* 1. ",
  newsDetailText11: "Please fill in the registration information of you and your companions to attend the MAIQS through the ",
  newsDetailText12: "online registration system",

  newsDetailText13: "and upload the payment voucher screenshot. Conference secretary will review your registration and payment information.",
  newsDetailTexttitle12: "* 2. ",
  newsDetailText14: "Hotel reservations are in progress. Please book your hotel room in advance through our MAIQS website in advance, click ",
  newsDetailText15: "here",

  newsDetailText16: "to make a reservation, you can pay on-site on the day of your arrival. We highly recommend booking your hotel room as early as possible!",
  newsDetailTexttitle13: "* 3. ",
  newsDetailText17: "If you need an invitation letter for a VISA, please click",
  newsDetailText18: "for the application process.",

  newsDetailTexttitle14: " * 4. ",
  newsDetailText19: 'You can find information about “Visa, Venue, Travel and Hotel” in the "For Attendees" menu of the MAIQS website.',

  newsDetailTexttitle15: " * Tips：",
  newsDetailText20: "We strongly recommend that you, fill in your registration information in the online registration system, which will make the payment and verification process go very smoothly. Even if you have already paid, please complete this online registration process. Thank you very much!",
  newsDetailText21: "Extension deadline for registration is October 1st",
  newsDetailText22: "-- Updated on September 9, 2024",
  newsDetailText23: "[Notification] The deadline for registration is extended until October 1st. ",
  newsDetailText24: "For information on Registration & Payment, Hotel reservations, VISA Invitation Letters, please click",
  newsDetailText25: "here",
  newsDetailText26: "*Tips: We strongly recommend that you complete your registration, hotel booking and visa invitation letter as early as possible, as this will minimize unnecessary hassle.",
  newsDetailText27: "In no particular order, under construction",
  newsDetailText28: "List of Sponsors",
  newsDetailText29: "23rd International Drying Symposium",
  newsDetailText30: "Tentative Program",
  newsDetailText31: "If you are unable to view this PDF file online, you can download this ",
  newsDetailText32: "Pdf file",
  newsDetailText33: "Newly Released Tentative Program !",
  newsDetailText34: "",
  newsDetailText35: "",
  newsDetailText36: "",
  newsDetailText37: "",
  newsDetailText38: "",
  newsDetailText39: "",
  newsDetailText40: "",


}


// WEBPACK FOOTER //
// ./src/utils/en.js